import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonMenu } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MenuService } from 'src/app/services/menu.service';
import { IMenuOption } from 'src/app/interfaces/menu-option.interface';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {

    // #region Propiedades
    @Input() menuId: string = 'main-menu';
    @ViewChild(IonMenu) menu: IonMenu;
    @ViewChild('mainContent') mainContent: ElementRef;
    @ViewChild('focusTrap') focusTrap: ElementRef;

    public options: IMenuOption[];

    constructor(
        private router: Router,
        private menuService: MenuService,
        private authService: AuthenticationService
    ) {
        this.options = this.menuService.getMenuOptions();
    }

    async navigateTo(path: string) {
        await this.menuService.navigateTo(path, this.menuId);
    }

    async closeMenu() {
        await this.menuService.closeMenu(this.menuId);
        this.onMenuClose();
    }

    async logout() {
        // Llamar al método de logout del servicio de autenticación, teniendo en cuenta que es una promesa (promise)
        this.authService.logout().then(async () => {
            await this.menuService.closeMenu(this.menuId); // Cerrar el menú
            this.router.navigateByUrl('/login', { replaceUrl: true }); // Navegar a la página de login
        });

    }

    // #region Métodos privados

    private onMenuClose() {
        console.log('El menú se ha cerrado');

        if (this.focusTrap && this.focusTrap.nativeElement) {
            this.focusTrap.nativeElement.focus();
        }

        // Asegurarse de que el router-outlet no tenga aria-hidden
        const routerOutlet = document.getElementById('main-content');
        if (routerOutlet) {
            routerOutlet.removeAttribute('aria-hidden');
        }
    }

    // #endregion
}
